import React from 'react';
import { useTemplate } from '../../Data/Templates';
import { PageLoading } from '../../Components/Loading';
import Form, { Actions, Conditional, RequiredValidator, Wysiwyg } from '../../Components/Form';
import Section, { Sections } from '../../Components/Containers/Section';
import Alert from '../../Components/Alert';

const Template = ({broadcast}) => {
    const {template, update} = useTemplate(broadcast?.templateId);

    if (!broadcast?.templateId) {
        return <Alert theme="error"
            title="No template"
            message="This broadcast does not have a template assigned to it"
        />
    }

    return template ? <Inner {...{broadcast, template, update}} /> : <PageLoading />;
}

const Inner = ({broadcast, template, update}) => {
    return <div>
        <Form data={template}
            onSubmit={(data) => update({...data, rich: null})}
            conditionalDependencies={[broadcast]}
            disabled={!(broadcast?.preSend ?? false)}
            waitForData
        >
            <Sections>
                <Conditional condition={formData => broadcast.channels.includes('Email')}>
                    <Section title="Email">
                        <Wysiwyg name="subjectUpgraded"
                            label="Subject line"
                            validators={[RequiredValidator]}
                            features={['mergetags']}
                            mode="singleLine"
                            bottomMargin="0"
                        />
                        <Wysiwyg name="html"
                            label="Body"
                            validators={[RequiredValidator]}
                            features={['mergetags', 'images', 'basicFormatting', 'moreFormatting', 'advancedFormatting']}
                            mode="html"
                            bottomMargin="50"
                            imageTags={[{name: 'Broadcast', value: 'Broadcast'}]}
                            previousTags={[{name: 'Logo', value: 'Standard'}]}
                        />
                    </Section>
                </Conditional>

                <Conditional condition={formData => broadcast.channels.includes('SMS')}>
                    <Section title="SMS">
                        <Wysiwyg name="shortUpgraded"
                            label="SMS Message"
                            validators={[RequiredValidator]}
                            features={['mergetags']}
                            mode="multiLine"
                            bottomMargin="10"
                            smsLengthWarning
                        />
                    </Section>
                </Conditional>
            </Sections>

            <Alert theme="info"
                icon="Info"
                title="Customer portal link"
                message="Unlike customer notifications, no links are automatically added to broadcasts.
                    You can add a link to the customer portal using the {{link}} template tag."
            />

            <Actions submit={{label: 'Save'}} />

        </Form>
    </div>
}

export default Template;